import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RequestReceivedModalPage } from './request-received-modal.page';

const routes: Routes = [
  {
    path: '',
    component: RequestReceivedModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RequestReceivedModalPageRoutingModule {}
